import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { Enum } from '../../../utility/enum.enum';
import { AppMessage } from './../../../Common/appMessage';
import { AppGlobals } from './../../../Common/Services/app.global';
import { SharedService } from './../../../Common/Services/shared.service';
import { Utility } from './../../../Common/Services/utility';
import { AppConfig } from 'app/Common/appConfiguration';
import { userRole_siteAdmin } from './../../../Common/appConstant';

@Component({
  selector: 'app-adm-update-site-admin',
  templateUrl: './adm-update-site-admin.component.html',
  styleUrls: ['./adm-update-site-admin.component.css']
})
export class AdmUpdateSiteAdminComponent implements OnInit {

  form: FormGroup;
  businessCenterFilteredOptions: any;
  locationOptions: any;
  id: number;
  pageConfig: {
    title: string,
    isSaveDisable: boolean,
    isEditDisable: boolean,
    isRetireDisable: boolean
  };
  constructor(private _sharedService: SharedService, public _utility: Utility, private _activatedRoute: ActivatedRoute
    , public _appMessage: AppMessage, private _appGlobal: AppGlobals) {
    this.form = new FormGroup(
      {
        businessCenterId: new FormControl('', Validators.required),
        locationId: new FormControl('', Validators.required),
        rhId: new FormControl('', Validators.required),
        firstName: new FormControl(''),
        lastName: new FormControl(''),
        email: new FormControl('', [Validators.pattern(AppConfig.emailPattern)]),
        contactNo: new FormControl('', [Validators.pattern(AppConfig.phoneNumberRegEx), Validators.required])
      }
    )
    this.pageConfig = {
      title: 'Site Administrator',
      isSaveDisable: false,
      isEditDisable: true,
      isRetireDisable: true
    }

    this.form.valueChanges
      .debounceTime(400)
      .subscribe(form => {
        if (!this.form.disabled && this.form.dirty) {
          this._utility.setTxnStatus(true); // display confirm box for FORM changes
        }
      });
  }

  ngOnInit() {
    this._appGlobal.routeWithID = false;
    this._utility.clearTxnStatus(); // close confirm box for FORM changes
    if (this._sharedService.businessCenterList) {
      this._utility.setDataInComboField('businessCenter', null, this.form.controls.businessCenterId, this);
    }

    this.setDataOnForm();

    this.form.controls.businessCenterId.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.businessCenterChanges(value);
      });
  }

  // when businessCenter Changes
  businessCenterChanges(value) {
    if (!this.form.disabled) {
      this.form.controls.locationId.setValue('');
    }
    let data = [];
    if (value && value.id) {
      data = this._sharedService.locationMappedWithBCenterList.filter(function (item) { if (item.parentId == value.id) return item });
    }
    this.locationOptions = data;
  }

  //set data in the edit form after getting it and set the required config of the page for edit
  setDataOnForm() {
    this.id = this._activatedRoute.snapshot.params['userProfileId']; // regional admin Primary Id
    if (this.id == 0) {
      this.pageConfig.title = 'Add ' + this.pageConfig.title;
    } else {
      this.getData();
      this.pageConfig.title = 'Edit ' + this.pageConfig.title;
      this.pageConfig.isSaveDisable = true;
      this.pageConfig.isEditDisable = false;
      this._utility.disableEnableForm(this.form, true);
    }
  }

  //getting data of site admin on the basis of its id
  getData() {
    let params = "?userRole="+userRole_siteAdmin+"&userId=" + this.id;
    this._utility.addLoaderCount();
    this._sharedService.getUsers(params).subscribe(
      response => {
        this._utility.onSuccessCallback(response, null, () => {
          let data = response.response.results[0];
          let customFieldMap = [
            { field: "locationId", map: "locationMappedWithBCenterId" }
          ];
          this.form.patchValue(this._utility.manageFormComboData(data, customFieldMap));
          if (data.status == Enum.StatusRetire) {
            this.pageConfig.isRetireDisable = true;
            this.pageConfig.isEditDisable = true;
            this.pageConfig.isSaveDisable = true;
          } else {
            this.pageConfig.isRetireDisable = false;
            this.pageConfig.isEditDisable = false;
            this.pageConfig.isSaveDisable = true;
          }
        });
      },
      error => {
        this._utility.onErrorCallback(error);
      });
  }

  //save new record/update existing record and set the page config accordingly
  onSave() {
    let formValues = this.form.getRawValue();
    formValues = this._utility.manageFormDataforSave(formValues);
    formValues.id = this.id;
    this._utility.addLoaderCount();
    this._sharedService.saveAdminDetail(formValues, Enum.RoleTypeSiteAdmin)
      .subscribe(
      (response: any) => {
        let msg = this.id == 0 ? this._appMessage.getItem['UMsg00030'] : this._appMessage.getItem['UMsg00031'];
        this._utility.onSuccessCallback(response, msg, () => {
          this.pageConfig.isEditDisable = false;
          this.pageConfig.isSaveDisable = true;
          if (this.id == 0) {
            this.pageConfig.isRetireDisable = false; // disable retire button after save new record
          }
          this.id = response.response.id; // set new user Id
          this._utility.disableEnableForm(this.form, true);
          this._utility.clearTxnStatus(); // close confirm box for FORM changes
        });
      }, error => this._utility.onErrorCallback(error));
  }

  //disable save button and form on click of edit
  onEdit() {
    this.pageConfig.isSaveDisable = false;
    this.pageConfig.isEditDisable = true;
    this._utility.disableEnableForm(this.form, false);
  }

  /**
   * @param status - pass true for activate & pass false to retire
   */
  onChangeStatus(status: boolean) {
    this._utility.doRetireActiveAdmin(this.id, Enum.RoleTypeSiteAdmin, status, () => {
      this.pageConfig.isSaveDisable = true;
      this.pageConfig.isEditDisable = !status;
      this.pageConfig.isRetireDisable = !status;
      this._utility.disableEnableForm(this.form, true);
    });
  }
}




// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-site-admin/adm-update-site-admin/adm-update-site-admin.component.ts